<div class="caption flex-center">Plangebiete</div>
<mat-nav-list class="flex-force flex-fill flex-row nav-list" [style.padding]="sidenavPadding()">
      <a mat-list-item 
        color="secondary"
        class="flex-col color-primary-contrast backcolor-primary-contrast menu-item"
        [ngClass]="appStateService.sidenavExpanded() ? 'menu-item-small' : (appStateService.navigationPlangebiet()=='ALLE' ? 'menu-item-large' : 'menu-item-hidden')"
        [routerLink]="'/' + appStateService.navigationMain()"
        (click)="onClick('ALLE')" >
        <span matListItemTitle class="flex-fill menu-title" [ngClass]="appStateService.navigationPlangebiet()=='ALLE' ? 'font-header-bold' : 'font-header'">ALLE</span>
    </a>
    <a mat-list-item color="secondary"
        class="flex-col color-primary-contrast backcolor-primary-contrast menu-item"
        [ngClass]="appStateService.sidenavExpanded() ? 'menu-item-small' : (appStateService.navigationPlangebiet()=='HCH' ? 'menu-item-large' : 'menu-item-hidden')"
        [routerLink]="'/' + appStateService.navigationMain()"
        (click)="onClick('HCH')" >
        <span matListItemTitle class="flex-fill  menu-title" [ngClass]="appStateService.navigationPlangebiet()=='HCH' ? 'font-header-bold' : 'font-header'">HCH</span>
    </a>
    <a mat-list-item color="secondary"
        class="flex-col color-primary-contrast backcolor-primary-contrast menu-item"
        [ngClass]="appStateService.sidenavExpanded() ? 'menu-item-small' : (appStateService.navigationPlangebiet()=='BBEG' ? 'menu-item-large' : 'menu-item-hidden')"
        [routerLink]="'/' + appStateService.navigationMain()"
        (click)="onClick('BBEG')"  >
        <span matListItemTitle class="flex-fill  menu-title" [ngClass]="appStateService.navigationPlangebiet()=='BBEG' ? 'font-header-bold' : 'font-header'">BBEG</span>
    </a>
    <a mat-list-item color="secondary"
        class="flex-col color-primary-contrast backcolor-primary-contrast menu-item"
        [ngClass]="appStateService.sidenavExpanded() ? 'menu-item-small' : (appStateService.navigationPlangebiet()=='GRA' ? 'menu-item-large' : 'menu-item-hidden')"
        [routerLink]="'/' + appStateService.navigationMain()"
        (click)="onClick('GRA')" >
        <span matListItemTitle class="flex-fill  menu-title" [ngClass]="appStateService.navigationPlangebiet()=='GRA' ? 'font-header-bold' : 'font-header'">GRA</span>
    </a>
    <a mat-list-item color="secondary"
        class="flex-col color-primary-contrast backcolor-primary-contrast menu-item"
        [ngClass]="appStateService.sidenavExpanded() ? 'menu-item-small' : (appStateService.navigationPlangebiet()=='SCHB' ? 'menu-item-large' : 'menu-item-hidden')"
        [routerLink]="'/' + appStateService.navigationMain()"
        (click)="onClick('SCHB')"  >
        <span matListItemTitle class="flex-fill  menu-title" [ngClass]="appStateService.navigationPlangebiet()=='SCHB' ? 'font-header-bold' : 'font-header'">SCHB</span>
    </a>
</mat-nav-list>

